export default __webpack_public_path__ + "static/media/paperclip-solid.5025cc7f.svg";